import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Header from '../Header';

class Demo extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
	}

	render() {
		return (
			<div className="demo-page">

				<Header headingText="Performance Prediction Prototype" />
				<form id="sizing-form">
					<div className="page-content">
						<h3 className="heading-2">Boat Info</h3>

						<div className="field-group">
							<label className="input-label" for="boat-builder">Builder</label>
							<input type="text" className="input-field" id="boat-builder" name="boat-builder" value="Test" />
						</div>
						<div className="field-group">
							<label className="input-label" for="boat-model">Model</label>
							<input type="text" className="input-field" id="boat-model" name="boat-model" value="Test" />
						</div>
						<div className="field-group">
							<label className="input-label" for="boat-year">Year</label>
							<input type="text" className="input-field" id="boat-year" name="boat-year" value="Test" />
						</div>
						<div className="field-group">
							<label className="input-label" for="displacement">Full Load Displacement</label>
							<input type="text" className="input-field" id="displacement" name="displacement" value="7370" />
						</div>
						<div className="field-group">
							<label className="input-label" for="gmt">Transverse Metacentric Height (GMT) (Do not estimate)</label>
							<input type="text" className="input-field" id="gmt" name="gmt" value="0.670" />
						</div>
						<div className="field-group">
							<label className="input-label" for="loa">Length Overall (LOA)</label>
							<input type="text" className="input-field" id="loa" name="loa" />
						</div>
						<div className="field-group">
							<label className="input-label" for="lwl">Waterline Length (LWL)</label>
							<input type="text" className="input-field" id="lwl" name="lwl" value="9.110" />
						</div>
						<div className="field-group">
							<label className="input-label" for="boa">Beam Overall (BOA)</label>
							<input type="text" className="input-field" id="boa" name="boa" />
						</div>
						<div className="field-group">
							<label className="input-label" for="bwl">Max Waterline Beam (BWL)</label>
							<input type="text" className="input-field" id="bwl" name="bwl" value="2.550" />
						</div>
					</div>
				</form>
			</div>
		);
	}
}

export default Demo;



// WEBPACK FOOTER //
// ./src/components/pages/Demo.js